import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class BulkActionApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.BULK_ACTION);
  }

  getTemplateDownloadUrl(actionType) {
    return `${
      process.env.REACT_APP_API_BASE_URL
    }${this.getResourceUrl()}bulk-action/?action_type=${actionType}`;
  }

  bulkFileUpload(data) {
    return this.createForm(data, 'bulk-action/');
  }
}

export default new BulkActionApi();
